import SearchTaxonomies from "./search-taxonomies";

export default SearchTaxonomies;